import { commonRequest } from "../../services/ApiCall";
import { Helpers } from "../../services/Helpers";

export const LocationService = {
  list: async () => {
    return await commonRequest("GET", `${Helpers.URL()}/api/admin/location/list`, {}, Helpers.token());
  },
  create: async (data) => {
    return await commonRequest("POST", `${Helpers.URL()}/api/admin/location/create`, data, Helpers.token());
  },
  update: async (id, data) => {
    return await commonRequest("PUT", `${Helpers.URL()}/api/admin/location/update/${id}`, data, Helpers.token());
  },
  remove: async (id) => {
    return await commonRequest("DELETE", `${Helpers.URL()}/api/admin/location/delete/${id}`, {}, Helpers.token());
  },
  toggleStatus: async (id) => {
    return await commonRequest("PATCH", `${Helpers.URL()}/api/admin/location/toggle-status/${id}`, {}, Helpers.token());
  },
};
